import { ChangeDetectionStrategy, Component, Input, OnDestroy, Output, EventEmitter } from '@angular/core';

import { INavDropdown } from './nav.dropdown.interface';

@Component({
    selector: 'mlp-ng-nav-dropdown',
    templateUrl: './nav.dropdown.component.html',
    styleUrls: ['./nav.dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class NavDropdownSharedComponent {
    @Input() links: INavDropdown;
    @Output() linkClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

    linkHasBeenClicked(): void {
        this.linkClicked.emit(true);
    }
}
